import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState, ISelectedProduct, IUpdateAmount } from './types'

export const SelectedProductsSlice = createSlice({
  name: 'selectedProductsSlice',
  initialState,
  reducers: {
    addSelectedProduct(state, action: PayloadAction<ISelectedProduct>) {
      const doesExist = state.find((product) => {
        return product.uniqueId === action.payload.uniqueId
      })
      if (doesExist && action.payload.menuItems) {
        const index = state.findIndex(
          (el) => el.uniqueId === action.payload.uniqueId
        )
        if (index !== -1) {
          state[index].amount += 1
        }
        return
      }
      if (doesExist && !action.payload.menuItems) {
        const filtered = state.filter(
          (el) => el.uniqueId !== action.payload.uniqueId
        )
        if (action.payload.amount) {
          state.length = 0
          state.push(...filtered, action.payload)
        } else {
          state.length = 0
          state.push(...filtered)
        }
        return
      }
      if (!doesExist && action.payload.amount) {
        state.push(action.payload)
      }
    },
    updateSelectedProductAmount(state, action: PayloadAction<IUpdateAmount>) {
      const index = state.findIndex(
        (el) => el.uniqueId === action.payload.uniqueId
      )
      if (index !== -1) {
        state[index].amount = action.payload.amount
      }
    },
    discardOneSelectedProduct(state, action: PayloadAction<string>) {
      const index = state.findIndex((el) => el.uniqueId === action.payload)
      if (index !== -1) {
        state.splice(index, 1)
      }
    },
    discardSelectedProducts(state) {
      state.length = 0
    },
  },
})

export default SelectedProductsSlice.reducer
